<button
  #toggleButton
  class="cx-hamburger"
  type="button"
  (click)="toggle()"
  [class.is-active]="isExpanded | async"
  [attr.aria-expanded]="isExpanded | async"
  aria-label="Menu"
  aria-controls="header-account-container, header-categories-container, header-locale-container"
  id="burger-icon"
  >
  @if ((isExpanded | async) === false) {
    <app-custom-icons [type]="iconTypes.MENU"></app-custom-icons>
  }
  @if (isExpanded | async) {
    <app-custom-icons [type]="iconTypes.PLUS_OHGAR"></app-custom-icons>
  }
</button>

<div class="aux-background" id="aux-background" (click)="toggle()"></div>

